import axios from 'axios';

const KEY = 'ht_offline_punches';
const API = `${window.__BACKEND_URL__}/api`;

export const getQueue = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
};

const save = (q) => {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new Event('ht-offline-queue'));
};

export const enqueuePunch = (action, extras = {}) => {
  const punch = {
    client_id: (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`),
    action,
    timestamp: new Date().toISOString(),
    ...extras,
  };
  save([...getQueue(), punch]);
  return punch;
};

// True only for REAL transport failures. A plain `!err.response` check also
// matched synchronous JS bugs, silently turning them into fake offline punches.
export const isNetworkError = (err) =>
  !!err && !err.response && (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !!err.request || (typeof navigator !== 'undefined' && navigator.onLine === false));

let syncing = false;
export const syncQueue = async (token) => {
  const q = getQueue();
  if (!q.length || syncing || !navigator.onLine || !token) return null;
  syncing = true;
  try {
    const { data } = await axios.post(
      `${API}/time-entries/offline-sync`,
      { punches: q },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    save([]); // server is idempotent per client_id — safe to clear on success
    return data;
  } catch {
    return null; // keep the queue; we'll retry on the next tick / online event
  } finally {
    syncing = false;
  }
};
